export default {
  common: {
    requests: 'Αιτήσεις',
    request: 'Ζήτηση',
    signUp: 'Εγγραφείτε',
    logOut: 'Αποσύνδεση',
    seeAll: 'Δείτε όλα',
    follow: 'Ακολουθήστε το',
    unfollow: 'Ακολουθήστε το',
    email: 'Ηλεκτρονικό ταχυδρομείο',
    fullName: 'Ονοματεπώνυμο',
    password: 'Κωδικός πρόσβασης',
    next: 'Επόμενο',
    addNew: 'Προσθήκη νέου',
    type: 'Τύπος',
    typeYourMessage: 'Πληκτρολογήστε το μήνυμά σας',
    yourMessage: 'Το μήνυμά σας',
    message: 'Μήνυμα',
    shoutOut: 'Shoutout!',
    story: 'Ιστορία',
    chat: 'Chat',
    featureComingSoon: 'This feature is coming soon!',
    okay: 'Okay',
    send: 'Στείλετε',
    delete: 'Διαγραφή',
    cancel: 'Ματαίωση',
    search: 'Αναζήτηση',
    back: 'Πίσω',
    goToHome: 'Go to Home',
    addShoutout: 'Προσθέστε shoutout',
    player: 'Παίκτης',
    text: 'Κείμενο',
    video: 'Βίντεο',
    comment: 'Σχόλιο',
    team: 'Ομάδα',
    country: 'Χώρας',
    city: 'Πόλη',
    userName: 'Όνομα χρήστη',
    following: 'Ακολουθώντας το',
    followers: 'Ακολουθητές',
    referals: 'Αναφορές',
    athletes: 'Αθλητές',
    shoutouts: 'Εκφωνήσεις',
    showMore: 'Εμφάνιση περισσότερων',
    showLess: 'Εμφάνιση λιγότερων',
    sport: 'Αθλητισμός',
    position: 'Θέση',
    league: 'Πρωτάθλημα',
    info: 'Πληροφορίες',
    repost: 'Αναδημοσίευση',
    share: 'Μοιραστείτε τον',
    confirmed: 'Επιβεβαιωμένος',
    refused: 'Αρνήθηκε',
    pending: 'Εκκρεμεί',
    canceled: 'Ακυρώθηκε',
    trending: 'Τάσεις',
    latest: 'Τελευταία',
    noData: 'Δεν υπάρχουν στοιχεία',
    from: 'από',
    to: 'προς',
    settings: 'Ρυθμίσεις',
    areYouSure: 'Είσαι σίγουρος',
    profile: 'Προφίλ',
    accept: 'Αποδοχή',
    refuse: 'Απορρίψτε όλα',
    missing: 'Λείπει το',
    select: 'Επιλέξτε',
    currency: 'Νόμισμα',
    zipCode: 'ZIP Code',
    goBack: 'Πηγαίνετε πίσω',
    done: 'Έγινε',
    remove: 'Αφαιρέστε το',
    date: 'Ημερομηνία',
    description: 'Περιγραφή',
    amount: 'Ποσό',
    upload: 'Ανέβασμα',
    getApp: 'Αποκτήστε APP',
    today: 'Σήμερα',
    yesterday: 'Χθες',
    tomorrow: 'Αύριο',
    confirm: 'Επιβεβαιώστε',
    confirmAll: 'Επιβεβαίωση όλων',
    login: 'Σύνδεση',
    ad: 'AD',
    aboutUs: 'Σχετικά με εμάς',
    fan: 'Ανεμιστήρας',
    athlete: 'Αθλητής',
    stats: 'Στατιστικά στοιχεία',
    posts: 'Θέσεις',
    store: 'Κατάστημα',
    or: 'Ή',
    shoutout: 'Shoutout!',
    proceed: 'Προχωρήστε',
    required: 'Απαιτείται',
    dismiss: 'Απορρίψτε το',
    save: 'Αποθήκευση',
    discard: 'Απορρίψτε το',
    submit: 'Υποβολή',
    live: 'Ζωντανό',
    openInbox: 'Άνοιγμα εισερχομένων',
    home: 'Αρχική σελίδα',
    searchDotDotDot: 'Αναζήτηση...',
    reply: 'Απάντηση',
    subscribers: 'Συνδρομητές',
    subscribed: 'Συνδρομημένος',
    subscribe: 'Εγγραφείτε!',
    unsubscribe: 'Απεγγραφή',
    fans: 'Θαυμαστές',
    teams: 'Της ομάδας',
    setup: 'Εγκατάσταση',
    feed: 'Ταίζω',
    messages: 'Μηνύματα',
    earlier: 'Νωρίτερα',
    apply: 'Εφαρμογή',
    oneOnOnes: 'Ένας προς έναν',
    sort: 'Ταξινόμηση',
    comingSoon: 'Ερχομαι συντομα',
    goLive: 'Πηγαίνετε ζωντανά',
    total: 'Συνολικό κόστος: ',
    pay: 'Πληρώστε {{amount}}',
    free: 'δωρεάν',
    location: 'Τοποθεσία',
    countries: 'Χώρες',
    more: 'περισσότερα',
    less: 'λιγότερο',
    block: 'Μπλοκ',
    unblock: 'Ξεμπλοκάρετε το',
    privacyPolicy: 'Πολιτική απορρήτου',
    termsAndConditions: 'Όροι και Προϋποθέσεις',
    createNew: 'Δημιουργία νέου',
    game: 'Παιχνίδι',
    unlock: 'Ξεκλειδώστε το',
    post: 'Δημοσίευση',
    uploadFile: 'Ανέβασμα αρχείου',
    checkIn: 'Πραγματοποίησε έλεγχο',
    unregisteredType: 'Μη καταχωρημένος τύπος',
    required: 'Απαιτείται',
    create: 'Δημιουργία',
    reply: 'Απάντηση'
  },
  sports: {
    americanFootball: 'Αμερικανικό ποδόσφαιρο',
    baseball: 'Μπέιζμπολ',
    basketball: 'Μπάσκετ',
    boxing: 'Πυγμαχία',
    cricket: 'Κρίκετ',
    soccer: 'Ποδόσφαιρο',
    mma: 'MMA',
    race: 'Οδήγηση αγωνιστικών αυτοκινήτων',
    tennis: 'Τένις',
    carRace: 'Οδήγηση αγωνιστικών αυτοκινήτων',
    acrobatics: 'Ακροβασία',
    airSports: 'Αθλητισμός στον αέρα',
    archery: 'Τοξοβολία',
    combatSports: 'Μαχητικά αθλήματα',
    cycling: 'Ποδηλασία',
    cueSports: 'Αθλήματα Cue',
    equestrianSports: 'Ιππικός αθλητισμός',
    golf: 'Γκολφ',
    handball: 'Χάντμπολ',
    iceSports: 'Σπορ στον πάγου',
    lacrosse: 'Λακρός',
    polo: 'Πόλο',
    weightlifting: 'Αρση βαρών',
    rowing: 'Κωπηλασία',
    softball: 'Σόφτμπολ',
    rugby: 'Ράγκμπι',
    volleyball: 'Βόλεϊ',
    coachingMentoring: 'Coaching & Mentoring',
    figureSkating: 'Καλιτεχνικό πατινάζ',
    formula1: 'Φόρμουλα 1',
    gymnastics: 'Γυμναστική',
    hockey: 'Χόκεϊ',
    kickboxing: 'Kickboxing',
    motorSports: 'Μηχανοκίνητα αθλήματα',
    muayThai: 'Muay Thai',
    olympics: 'Ολυμπιακοί Αγώνες',
    poleSports: 'Pole Sports',
    sportsInfluencer: 'Αθλητική επιρροή',
    swimming: 'Κολύμπι',
    trackField: 'Στίβος & Πεδίο',
    visualArtist: 'Εικαστικός καλλιτέχνης',
    wheelchairRugby: 'Ράγκμπι με αμαξίδιο',
    wrestling: 'Πάλη',
    iceHockey: 'Χόκεϊ επί πάγου',
    alpineSkiing: 'Αλπικό σκι',
    flagFootball: 'Ποδόσφαιρο σημαίας',
    climbing: 'Αναρρίχηση',
    badminton: 'Badminton',
    motorcycleRacing: 'Αγώνες μοτοσικλετών'
  },
  levels: {
    interested: 'Ενδιαφερόμενος',
    beginner: 'Αρχάριοι',
    amateur: 'Ερασιτέχνης',
    intermediate: 'Ενδιάμεσο',
    expert: 'Εμπειρογνώμονας',
    retired: 'Συνταξιούχος'
  },
  auth: {
    signUpFacebook: 'Εγγραφείτε με το Facebook',
    signUpGoogle: 'Εγγραφείτε στο Google',
    signUpPaypal: 'Εγγραφείτε με το PayPal',
    forgottenPassword: 'Ξεχάσατε τον κωδικό πρόσβασής σας;',
    logInFacebook: 'Συνδεθείτε με το Facebook',
    logInGoogle: 'Συνδεθείτε με το Google',
    logInPaypal: 'Συνδεθείτε με το PayPal',
    dontHaveAccount: 'Δεν έχετε λογαριασμό;',
    mustContain8Characters: 'Πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες. ',
    alreadyHaveAccount: 'Έχετε ήδη λογαριασμό;',
    passwordReset: 'Επαναφορά κωδικού πρόσβασης',
    resetInstructions:
      'Εισάγετε το email που σχετίζεται με το λογαριασμό σας και θα σας στείλουμε τις οδηγίες ανάκτησης του κωδικού πρόσβασης.',
    sendRecoveryEmail: 'Αποστολή email ανάκτησης',
    backTo: 'Πίσω στο',
    logIn: 'Συνδεθείτε',
    checkEmail: 'Ελέγξτε τη διεύθυνση email σας',
    noAccount: 'Δεν υπάρχει σχετικός λογαριασμός',
    pleaseTryAnother: 'Παρακαλώ δοκιμάστε άλλη διεύθυνση.',
    tryAnother: 'Δοκιμάστε άλλο email',
    emailSent: 'Στάλθηκε email ανάκτησης',
    checkEmailInstructions:
      'Ελέγξτε τα εισερχόμενά σας (και τους φακέλους ανεπιθύμητης αλληλογραφίας) για να βρείτε και να ακολουθήσετε τις οδηγίες για την επαναφορά του κωδικού πρόσβασής σας.',
    createNewPassword: 'Δημιουργία νέου κωδικού πρόσβασης',
    newPassword: 'Νέος κωδικός πρόσβασης',
    confirmPassword: 'Επιβεβαίωση κωδικού πρόσβασης',
    resetPassword: 'Επαναφορά κωδικού πρόσβασης',
    validateYourEmail: 'Επικυρώστε το email σας',
    validateEmailInstructions:
      'Πρέπει να επικυρώσετε το email σας για την ενεργοποίηση του νέου σας λογαριασμού P4P.',
    confirmEmail: 'Επιβεβαίωση email',
    validationEmailSent: 'Αποστολή email επικύρωσης',
    checkInboxToValidateEmail:
      'Ελέγξτε τα εισερχόμενά σας (και τους φακέλους ανεπιθύμητης αλληλογραφίας) για να βρείτε και να ακολουθήσετε τις οδηγίες για να επικυρώσετε το email σας.',
    getTheApp: 'Αποκτήστε την εφαρμογή',
    accountLocked: 'Ο λογαριασμός σας είναι κλειδωμένος',
    accountLockedDesc:
      'Διατηρούμε τα πράγματα ασφαλή και έχουμε κλειδώσει το λογαριασμό σας λόγω πολλών προσπαθειών με λάθος διαπιστευτήρια. Παρακαλούμε ελέγξτε τα εισερχόμενά σας για να επαναφέρετε τον κωδικό πρόσβασής σας.',
    checkInbox: 'Ελέγξτε τα εισερχόμενά μου',
    youAcceptTerms:
      'Με την εγγραφή ή την είσοδό σας, συμφωνείτε με τους Όρους και Προϋποθέσεις και την Πολιτική Απορρήτου.',
    logInApple: 'Σύνδεση με την Apple',
    signUpApple: 'Εγγραφείτε στην Apple'
  },
  messages: {
    newMessages: 'Νέα μηνύματα',
    newGroup: 'Νέα ομάδα',
    favorites: 'Αγαπημένα',
    favoritesAtTop: 'Αγαπημένα στην κορυφή',
    favoritesOnly: 'Μόνο τα αγαπημένα',
    excludeHidden: 'Εξαίρεση κρυφών',
    showHidden: 'Εμφάνιση κρυμμένου',
    hiddenChats: 'Κρυφές συνομιλίες',
    message: 'Μήνυμα',
    addChat: 'Προσθήκη συνομιλίας',
    searchFriends: 'Αναζήτηση φίλων',
    createdGroup: '{{group}} δημιούργησε αυτή την ομάδα',
    totalMessageSingular: '1 Νέο μήνυμα',
    totalMessages: '{{totalMessageCount}} Νέα μηνύματα',
    noChats: 'Δεν υπάρχουν διαθέσιμες συνομιλίες.',
    noChatSelected: 'Δεν έχει επιλεγεί συνομιλία.',
    messageDotDotDot: 'Μήνυμα...',
    noChatYet: 'Δεν υπάρχει συνομιλία εδώ ακόμα...',
    searchFriendsGroups: 'Αναζήτηση φίλων ή ομάδων...',
    selectFriend: 'Επιλέξτε φίλο',
    groupChatName: 'Όνομα ομαδικής συνομιλίας',
    startChat: 'Έναρξη συνομιλίας',
    youNeedSub: 'Πρέπει να εγγραφείτε στο {{name}} για να στείλετε ένα μήνυμα',
    youBlocked: 'Έχετε μπλοκάρει αυτόν τον χρήστη'
  },
  home: {
    latestPosts: 'Τελευταίες θέσεις',
    confirmed: 'Επιβεβαιωμένο',
    playazRunsSafeEnvironment: 'Το Playaz παρέχει ένα ασφαλές περιβάλλον',
    connectionsConverstationsFollowedAthletes:
      'Συνδέσεις ομοϊδεατών για συζητήσεις, ομαδικές συναντήσεις και μάθηση από τους αθλητές που σας ακολουθούν.',
    myPosts: 'Οι θέσεις μου',
    accountsToFollow: 'Λογαριασμοί προς παρακολούθηση',
    comingUp: 'Έρχεται',
    gloriousWinners: 'Ένδοξοι νικητές',
    todaysGames: 'Τα σημερινά παιχνίδια',
    athleteHighlights: 'Σημαντικότερες στιγμές αθλητή',
    fanHighlights: 'Σημεία αναφοράς ανεμιστήρων',
    todaysMatches: 'Οι σημερινοί αγώνες'
  },
  add: {
    followers: 'Ακολουθητές',
    subscribers: 'Συνδρομητές',
    onlyMe: 'Μόνο εγώ',
    photoVideo: 'φωτογραφιών/βίντεο',
    tag: 'Tag',
    correctLink: 'Παρακαλώ προσθέστε έναν σωστό σύνδεσμο.',
    teamOrPlayer: 'Ομάδα ή παίκτης',
    editMedia: 'Επεξεργασία μέσων ενημέρωσης',
    tapCrop: 'Πατήστε σε μια εικόνα για να την περικόψετε.',
    gallery: 'Γκαλερί',
    addMultiple: 'Προσθήκη πολλαπλών',
    shoutOutTo: 'Shout out to',
    whereItHappens: 'Πού συμβαίνει',
    shouldAcceptTerms: 'Πρέπει να αποδεχτείτε τους Όρους & Προϋποθέσεις',
    summary: 'Περίληψη',
    total: 'Συνολικό κόστος: ',
    iAcceptTerms:
      'Σύμφωνα με τους όρους και τις προϋποθέσεις, αποδέχομαι να χρεωθώ με το ποσό που αναφέρεται παραπάνω κατά την επιβεβαίωση του αθλητή.',
    post: 'Δημοσίευση',
    enterYoutubeLink: 'Εισάγετε το σύνδεσμο Youtube',
    tagFriends: 'Ετικέτα φίλοι',
    shareWith: 'Μοιραστείτε με',
    everyone: 'Όλοι',
    peopleFollowBack: 'Μόνο οι άνθρωποι που ακολουθώ πίσω',
    linkToVideo: 'Σύνδεσμος στο βίντεο',
    swipeRightPurchase: 'Σαρώστε δεξιά για να αγοράσετε',
    uploadMedia: 'Ανέβασμα πολυμέσων',
    shareLink: 'Μοιραστείτε τον σύνδεσμο',
    correctYoutubeLink: 'Παρακαλώ προσθέστε έναν σωστό σύνδεσμο στο Youtube.',
    writeCaption: 'Γράψτε μια λεζάντα',
    selectionsWillRemove:
      'Μπορείτε να δημοσιεύσετε μόνο ένα βίντεο, άλλες επιλογές θα αφαιρεθούν. Προχωρήστε;',
    selectVideo: 'Επιλέξτε βίντεο',
    onlySingleVideo: 'Προς το παρόν μπορείτε να δημοσιεύσετε μόνο ένα βίντεο.',
    upToAMinutes: 'Επιτρέπεται μέγιστη διάρκεια βίντεο 1 λεπτό.',
    text: 'Κείμενο',
    video: 'Βίντεο',
    tagPeople: 'Κάντε tag ανθρώπους',
    enterLink: 'Εισάγετε σύνδεσμο',
    linkToOriginalPost: 'Σύνδεσμος στην αρχική ανάρτηση',
    pasteForPreview: 'Επικολλήστε το σύνδεσμο για να δείτε την προεπισκόπηση της δημοσίευσης',
    createPost: 'Δημιουργήστε θέση...',
    recent: 'Πρόσφατο',
    noUserFound: 'Δεν βρέθηκαν χρήστες με τα κριτήρια που ταιριάζουν',
    searchResults: 'Αποτελέσματα αναζήτησης',
    storyPublished: 'Η ιστορία δημοσιεύτηκε!',
    live: 'Ζωντανό',
    shoutout: 'Shoutout!',
    addPhotosAndVideos: 'Προσθήκη φωτογραφιών & βίντεο',
    addLocation: 'Προσθήκη τοποθεσίας',
    onlyForSubscribers: 'Μόνο για συνδρομητές',
    photosAndVideos: 'Φωτογραφίες & βίντεο',
    selectUpTo10: 'Επιλέξτε έως και 10',
    suggested: 'Προτεινόμενο',
    shoutoutTo: 'Φωνάξτε στο',
    createShoutout: 'Δημιουργία Shoutout',
    newShoutout: 'Νέο Shoutout',
    tapOrHold: 'Πατήστε για φωτογραφία, κρατήστε πατημένο για βίντεο',
    tapGoLive: 'Πατήστε για να μεταβείτε σε ζωντανή μετάδοση',
    addNewPost: 'Προσθήκη νέας δημοσίευσης',
    addNewShoutout: 'Προσθέστε νέο shoutout',
    fileFormats: 'Μορφές αρχείων JPEG, PNG, MP4, WebM ή Ogg',
    create: 'Δημιουργία',
    createNewShoutout: 'Δημιουργία Νέου Χαιρετισμού',
    createNewPost: 'Δημιουργία Νέας Ανάρτησης'
  },
  browse: {
    trySearchAthlete: 'Δοκιμάστε να αναζητήσετε έναν αθλητή, μια ομάδα ή ένα hashtag',
    basedYourPreferences:
      'Με βάση τις προτιμήσεις σας, δείτε μερικούς αθλητές και οπαδούς που μπορεί να σας αρέσει να ακολουθείτε.',
    erlingHaaland: 'Erling Haaland',
    parisSaintGermain: 'Παρί Σεν Ζερμέν',
    trendingPosts: 'Τρέχουσες αναρτήσεις',
    chooseSportAndFavoriteTeam:
      'Επιλέξτε αθλήματα και επιλέξτε την αγαπημένη σας ομάδα αθλητών που θα σας κρατάει ενήμερους.',
    trendingTeams: 'Τρέχουσες ομάδες',
    seeTeamsYourFellow:
      'Δείτε τις ομάδες που ακολουθούν οι φίλαθλοι και οι αθλητές σας αυτή τη στιγμή.',
    atalanta: 'Αταλάντα',
    serieaFootballClub: 'Serie A Ποδοσφαιρικός σύλλογος',
    browse: 'Περιήγηση στο',
    athletesOnPlatform: 'Αθλητές στο P4P',
    fansOnPlatform: 'Οπαδοί στο P4P',
    upcomingEvents: 'Επόμενες εκδηλώσεις',
    eventsComingUpYourFavorite:
      'Εκδηλώσεις που έρχονται με βάση τα αγαπημένα σας αθλήματα, ομάδες και αθλητές.',
    superBantamweight: 'Super Bantamweight',
    tiffanyVanSoestAlinePereira: 'Tiffany van Soest - Aline Pereira',
    chicagoVenue: 'Σικάγο, Σικάγο Χώρος',
    suggestedAthletes: 'Προτεινόμενοι αθλητές',
    suggestedFans: 'Προτεινόμενοι ανεμιστήρες',
    suggestedAccounts: 'Προτεινόμενοι λογαριασμοί',
    newAppHasArrived: 'Η νέα μας εφαρμογή έφτασε!',
    newAppDesc:
      'Εμπλουτίσαμε την εμπειρία σας στο P4P με τα σχόλιά σας. Απολαύστε την ενημερωμένη εφαρμογή και μείνετε συντονισμένοι για περαιτέρω ενημερώσεις.',
    seeTheApp: 'Δείτε την APP',
    postCountSingular: '1 θέση',
    postCountPlural: '{{count}} θέσεις',
    recent: 'Πρόσφατο',
    top: 'Κορυφή',
    athletes: 'Αθλητές',
    teams: 'Της ομάδας',
    tags: 'Ετικέτες',
    fans: 'Θαυμαστές',
    trendingShoutouts: 'Τρέχουσες αναφωνήσεις',
    goBrowse: 'Πηγαίνετε να περιηγηθείτε',
    follower: 'ακόλουθος',
    followers: 'ακόλουθοι',
    todaysGames: 'Τα σημερινά παιχνίδια',
    trendingAthletes: 'Τρέχοντες αθλητές',
    trendingFans: 'Τρέχοντες ανεμιστήρες',
    allAthletes: 'Όλοι οι αθλητές',
    allFans: 'Όλοι οι οπαδοί',
    sortBy: 'Ταξινόμηση κατά',
    name: 'Όνομα',
    popularity: 'Δημοτικότητα',
    recentlyRegistered: 'Πρόσφατα εγγεγραμμένος',
    filterByConnection: 'Φίλτρο ανά σύνδεση',
    showAll: 'Εμφάνιση όλων',
    showOnlyConnect: 'Δείξτε μόνο τους αθλητές που μπορείτε να συνδέσετε',
    teamsOnPlatform: 'Ομάδες στο P4P',
    allTeams: 'Όλες οι ομάδες',
    todaysMatches: 'Οι σημερινοί αγώνες'
  },
  chat: {
    muteNotifications: 'Σίγαση ειδοποιήσεων',
    removeFavorites: 'Αφαίρεση από τα αγαπημένα',
    addFavorites: 'Προσθήκη στα αγαπημένα',
    clearChatHistory: 'Εκκαθάριση ιστορικού συνομιλίας',
    youCannotAction: 'Δεν μπορείτε να αναιρέσετε αυτή την ενέργεια.',
    deleteConversationWith: 'Διαγραφή συνομιλίας με ',
    deleteConversation: 'Διαγραφή συνομιλίας',
    unhideChat: 'Απόκρυψη συνομιλίας',
    hideChat: 'Απόκρυψη συνομιλίας',
    clearHistory: 'Εκκαθάριση ιστορικού',
    noResults: 'Κανένα αποτέλεσμα...',
    noMessagesYet: 'Δεν υπάρχουν μηνύματα εδώ ακόμα...',
    returnChat: 'Επιστροφή στη συνομιλίας',
    searchMessages: 'Αναζήτηση μηνυμάτων...',
    clearConfirmation: 'Είστε σίγουρος ότι θέλετε να διαγράψετε αυτή τη συνομιλία;',
    deleteConfirmation: 'Είστε σίγουροι ότι θέλετε να διαγράψετε αυτή τη συνομιλία;',
    block: 'Μπλοκ',
    disableSound: 'Απενεργοποίηση ήχου',
    muteNotificationsFor: 'Σίγαση ειδοποιήσεων για...',
    thirtyMinutes: '30 λεπτά',
    oneHour: '1 ώρα',
    oneDay: '1 ημέρα',
    oneWeek: '1 εβδομάδα',
    oneMonth: '1 μήνας',
    muteForever: 'Σίγαση για πάντα'
  },
  comments: {
    succesfullyReactedPost: 'Αντέδρασε με επιτυχία σε αυτήν την ανάρτηση.',
    beFirstReaction: 'Γίνετε ο πρώτος που θα αντιδράσει',
    comments: 'Σχόλια',
    noComments: 'Κανένα σχόλιο',
    comment: 'Σχόλιο'
  },
  connect: {
    endOneOnOneWith: 'Τέλος Face2Face με ',
    youWontGoBackCall: 'Δεν θα μπορείτε να επιστρέψετε σε αυτή την πληρωμένη κλήση.',
    sayGoodBye: 'Πείτε αντίο στο ',
    timeToWrapUp: 'Ώρα να κλείσουμε',
    oneOnOneCall: 'Τηλεφωνική επικοινωνία ένας προς έναν',
    setupConnect: 'Ρύθμιση Face2Face'
  },
  connectConfirmations: {
    cancelOneOnOne: 'Ακύρωση ένας προς έναν',
    unfortunatelyCanceled: 'Δυστυχώς, η προσωπική σας σύνδεση με {{name}} ακυρώθηκε.',
    timeToStart: "Ήρθε η ώρα να ξεκινήσετε την κράτηση 15 λεπτών κατ' ιδίαν με το {{name}}",
    swipeCancel: 'Σύρετε προς τα δεξιά για να ακυρώσετε τη σύνδεση',
    wantCancelOneOnOne: 'Θέλετε να ακυρώσετε το Face2Face',
    youWillPay: 'Αυτό δεν μπορεί να αναιρεθεί και θα πληρώσετε ένα τέλος ακύρωσης ({{amount}})',
    fanWillGet:
      'Αυτό δεν μπορεί να αναιρεθεί και ο θαυμαστής θα λάβει 100% επιστροφή χρημάτων ({{amount}})',
    swipeRightStart: 'Σύρετε προς τα δεξιά για να ξεκινήσετε τη σύνδεση',
    oneOnOneConnectEnded: 'Η σύνδεση ένας προς έναν τερματίστηκε',
    '15minCall':
      'Η 15λεπτη κλήση σας με {{name}} και ελπίζουμε να είχατε μια συναρπαστική συνομιλία με τον αγαπημένο σας αθλητή.',
    bookAnotherOneOnOne: 'Κάντε κράτηση άλλου ένας προς έναν',
    refuseOneOnOne: 'Αρνηθείτε ένας προς έναν',
    wantRefuseOneOnOne: 'Θέλεις να αρνηθείς το τετ-α-τετ με τον {{name}}',
    swipeRightRefuseConnect: 'Σαρώστε προς τα δεξιά για να αρνηθείτε τη σύνδεση',
    '15minCallWithAthlete':
      'Η 15λεπτη κλήση σας με τον {{name}}, και ελπίζουμε να είχατε μια συναρπαστική συζήτηση με τον αγαπημένο σας αθλητή.',
    waitingInLobby: 'Περιμένοντας στο λόμπι...',
    pleaseWaitUser:
      'Παρακαλώ περιμένετε να ξεκινήσει το τετ-α-τετ σας με <strong>{{name}}<\/strong>.',
    refusedOneOnOneConnect: 'Αρνήθηκε τη σύνδεση Face2Face',
    callSettings: 'Ρυθμίσεις κλήσης:'
  },
  settings: {
    referAnAthlete: 'Παραπέμψτε έναν αθλητή',
    upgradePlan: 'Σχέδιο αναβάθμισης',
    settings: 'Ρυθμίσεις',
    changePassword: 'Αλλαγή κωδικού πρόσβασης',
    oldPassword: 'Παλαιός κωδικός πρόσβασης',
    newPassword: 'Νέος κωδικός πρόσβασης',
    privacyAndSecurity: 'Απόρρητο & ασφάλεια',
    profilePrivacySettings: 'Ρυθμίσεις απορρήτου προφίλ',
    whoCanView: 'Ποιος μπορεί να δει τη σελίδα του προφίλ σας;',
    whoCanViewInfo: 'Ποιος μπορεί να δει την καρτέλα πληροφοριών στη σελίδα του προφίλ σας;',
    whoCanViewBasicInfo: 'Ποιος μπορεί να δει τις βασικές σας πληροφορίες;',
    whoCanViewLocation: 'Ποιος μπορεί να δει την τοποθεσία σας;',
    whoCanViewActivities:
      'Ποιος μπορεί να δει την ενότητα δραστηριοτήτων στη σελίδα του προφίλ σας;',
    whoCanShare: 'Ποιος μπορεί να μοιραστεί μια ανάρτηση στον τοίχο σας;',
    whoCanViewFriends: 'Ποιος μπορεί να δει τη λίστα των φίλων σας;',
    whoCanSendFriends: 'Ποιος μπορεί να μου στείλει αίτημα φιλίας;',
    whoCanSendMessage: 'Ποιος μπορεί να σας στείλει μήνυμα;',
    whoCanViewPhotos: 'Ποιος μπορεί να δει τις φωτογραφίες στη σελίδα του προφίλ σας;',
    whoCanPokes: 'Ποιος μπορεί να στέλνει σπρωξίματα;',
    whoCanViewViewed: 'Ποιος μπορεί να δει ποιος είδε πρόσφατα το προφίλ σας;',
    whoCanTag: 'Ποιος μπορεί να με επισημάνει σε γραπτά συμφραζόμενα;',
    whoCanSeeDateOfBirth: 'Ποιος μπορεί να δει την ημερομηνία γέννησής σας;',
    allowSharing: 'Επιτρέψτε την κοινή χρήση από',
    allowMentions: 'Επιτρέψτε αναφορές από',
    allowTags: 'Επιτρέψτε ετικέτες από',
    avilabilityPeriod: 'Περίοδος διαθεσιμότητας',
    pleaseShare:
      'Παρακαλούμε μοιραστείτε τις μηνιαίες προσδοκίες σας για τα έσοδα. Οι θαυμαστές δεν θα το δουν αυτό στο προφίλ σας.',
    customPeriod: 'Προσαρμοσμένη περίοδος...',
    from: 'Από',
    to: 'προς',
    selectStart: 'Επιλέξτε ημερομηνία έναρξης',
    selectEnd: 'Επιλέξτε ημερομηνία λήξης',
    total: 'Συνολικό κόστος: ',
    pendingRequest: 'Εκκρεμείς αιτήσεις',
    invalid: 'άκυρο',
    today: 'Σήμερα',
    months: 'Μήνες',
    weeks: 'Εβδομάδες',
    setAvailability: 'Ορισμός διαθεσιμότητας',
    fansWillOnly:
      'Οι οπαδοί θα μπορούν να κλείσουν μόνο ένα τετ-α-τετ εντός των διαθέσιμων χρόνων.',
    period: 'Περίοδος',
    dayOfTheWeek: 'Ημέρα της εβδομάδας',
    daily: 'Καθημερινά',
    thisWeek: 'Αυτή την εβδομάδα',
    thisMonth: 'Αυτόν τον μήνα',
    availableTime: 'Διαθέσιμος χρόνος',
    time: 'Χρόνος',
    timeBetween: 'Χρόνος μεταξύ συνδέσεων',
    breakDuration: 'Διάρκεια διαλείμματος',
    setAvailableTime: 'Ορίστε τον διαθέσιμο χρόνο σε',
    chooseATime:
      "Επιλέξτε μια ώρα κατά τη διάρκεια της ημέρας κατά την οποία θέλετε να λάβετε κατ' ιδίαν αιτήματα για να",
    weekDays: 'Εβδομαδιαίες ημέρες',
    weekends: 'Σαββατοκύριακα',
    oneOnOneConnect: 'Αρνήθηκε τη σύνδεση Face2Face',
    save: 'Αποθήκευση',
    search: 'Αναζήτηση',
    subscriptions: 'Συνδρομές',
    emailNotifications: 'Ειδοποιήσεις μέσω email',
    languageAndCurrency: 'Γλώσσα & νόμισμα',
    theme: 'Θέμα',
    billing: 'Τιμολόγηση',
    accessBilling: 'Πρόσβαση σε πληροφορίες χρέωσης',
    logOut: 'Αποσύνδεση',
    countryCode: 'Κωδικός χώρας',
    selectCountry: 'Επιλέξτε χώρα',
    passwordChangeSuccessful: 'Ενημερώσατε με επιτυχία τον κωδικό πρόσβασής σας.',
    confirmNewPassword: 'Επιβεβαίωση νέου κωδικού πρόσβασης',
    forgotPassword: 'Ξεχάσατε τον κωδικό πρόσβασης;',
    enableEmailNotifications: 'Ενεργοποίηση ειδοποιήσεων email',
    newComments: 'Νέα σχόλια',
    newTags: 'νέες Ετικέτες',
    newSubscriptions: 'Νέες συνδρομές',
    newFriends: 'Νέοι φίλοι',
    friendRequests: 'Αιτήματα φιλίας',
    notificationForLikes: 'Ειδοποίηση για "Likes"',
    newMessages: 'Νέα μηνύματα',
    photosNotifications: 'Ειδοποιήσεις φωτογραφιών',
    language: 'Γλώσσα',
    currency: 'Νόμισμα',
    anyone: 'Οποιοσδήποτε',
    community: 'Κοινότητα',
    friendsOnly: 'Μόνο φίλοι',
    noOne: 'Κανείς',
    onlyAvailableViaApp: 'Διατίθεται μόνο μέσω APP για κινητά',
    darkMode: 'Σκοτεινή λειτουργία',
    contentPrivacySettings: 'Ρυθμίσεις απορρήτου περιεχομένου',
    setAvailableTimeTo: 'Ορίστε τον διαθέσιμο χρόνο σε',
    chooseATimeTo:
      "Επιλέξτε μια ώρα κατά τη διάρκεια της ημέρας κατά την οποία θέλετε να λάβετε κατ' ιδίαν αιτήματα για να",
    removeAccount: 'Κατάργηση λογαριασμού',
    accountPrivacy: 'Λογαριασμός'
  },
  scheduleConnect: {
    '15minutesCall': 'Τηλεφώνημα 15 λεπτών',
    thereIsNo: 'Δεν υπάρχει διαθεσιμότητα για αυτή την ημερομηνία.',
    selectTime: 'Επιλέξτε χρόνο',
    bookOneOnOne: 'Κάντε κράτηση Face2Face',
    youAlreadyHave: 'Έχετε ήδη συνδεθεί με αυτόν τον αθλητή.',
    scheduleAlreadyExist: 'Το χρονοδιάγραμμα υπάρχει ήδη',
    ad: 'AD',
    nextAvailableSlot: 'Επόμενη διαθέσιμη θέση',
    noScheduleFound: 'Δεν βρέθηκε πρόγραμμα',
    thisUserHasnt:
      'Αυτός ο χρήστης δεν έχει ορίσει ακόμα το πρόγραμμά του. Παρακαλείστε να επανέλθετε αργότερα.',
    schedule: 'Πρόγραμμα',
    today: 'Σήμερα',
    tomorrow: 'Αύριο',
    weeks: 'Εβδομάδες',
    seeCalendar: 'Δείτε το ημερολόγιο',
    dateAndTime: 'Ημερομηνία και ώρα',
    edit: 'Επεξεργασία',
    total: 'Συνολικό κόστος: ',
    asPerTheTerms:
      'Σύμφωνα με τους όρους και τις προϋποθέσεις, αποδέχομαι να χρεωθώ με το ποσό που αναφέρεται παραπάνω κατά την επιβεβαίωση του αθλητή.',
    sendRequest: 'Στείλτε αίτημα',
    oneOnOneRequest: 'Αποστολή αιτήματος Face2Face',
    afterTheAthleteAccepts:
      'Αφού ο αθλητής αποδεχτεί το αίτημά σας, θα λάβετε την ειδοποίηση και θα δείτε το εκκρεμές Face2Face στο ταμπλό.',
    goToDashboard: 'Πηγαίνετε στο ταμπλό',
    bookOtherOneOnOne: 'Κλείστε άλλα Face2Face',
    proceed: 'Προχωρήστε',
    searcAthletes: 'Αναζήτηση αθλητών',
    notVerified: 'Αυτό το προφίλ δεν είναι επαληθευμένος αθλητής.',
    bookOneOnOneTeam: 'Booking a Face2Face? Please select your favorite athlete. Thank you!',
    noBooked: 'Δεν έχετε κλείσει ακόμα Face2Face',
    bookedYet: 'Έχετε κάνει κράτηση για ένα τετ-α-τετ;',
    selectDay: 'Επιλέξτε ημέρα',
    nextOneOnOnes: 'Επόμενο Face2Face',
    noResults:
      'Όλοι οι αθλητές μας έχουν ένα γεμάτο πρόγραμμα. Οι διαθεσιμότητες ανοίγουν τακτικά, οπότε παρακαλούμε να επανέλθετε αργότερα.'
  },
  connectsDashboard: {
    byFan: 'ΑΠΟ ΦΑΝ',
    byAthlete: 'ΑΠΟ ΑΘΛΗΤΗ',
    pending: 'Εκκρεμεί',
    confirmed: 'Επιβεβαιωμένο',
    rejected: 'Απορρίφθηκε',
    timeBooked: 'Χρόνος κράτησης',
    refuseOneOnOneConnect: 'Απορρίψτε όλα τα Face2Face για ',
    refuseAll: 'Απορρίψτε όλα',
    oneOnOneConnect: 'Αρνήθηκε τη σύνδεση Face2Face',
    bookAgain: 'Κάντε κράτηση ξανά'
  },
  dashboard: {
    monthlyTarget: 'Επεξεργασία μηνιαίου στόχου',
    setMonthlyRevenueTarget: 'Δεν έχετε ορίσει ακόμη τον μηνιαίο στόχο των εσόδων σας.',
    useAthleteRefferalCodes:
      'Χρησιμοποιήστε κωδικούς παραπομπής αθλητών για να μεγαλώσετε την ομάδα',
    setupRateAndAvailability:
      'Ρυθμίστε το ποσοστό και τη διαθεσιμότητα για να λαμβάνετε αιτήματα Face2Face.',
    shoutouts: 'Εκφωνήσεις',
    vipConnect: 'VIP Connect',
    week: 'Εβδομάδα',
    month: 'Μήνας',
    year: 'Έτος',
    all: 'Όλα',
    custom: 'Προσαρμοσμένη...',
    total: 'Συνολικό κόστος: ',
    dashboard: 'Ταμπλό',
    referrals: 'Παραπομπές',
    income: 'Εισόδημα',
    users: 'Χρήστες',
    subscribed: 'Συνδρομημένος',
    progress: 'Πρόοδος',
    followers: 'Ακολουθητές',
    advertising: 'Διαφήμιση',
    views: 'Προβολές',
    number: 'Αριθμός',
    athleteEmail: 'Email αθλητή',
    meetings: 'Συναντήσεις',
    itemsSold: 'Πωληθέντα αντικείμενα',
    store: 'Κατάστημα',
    editMonthlyTarget: 'Επεξεργασία μηνιαίου στόχου',
    inviteToGrow: 'Πληκτρολογήστε email για να στείλετε μια πρόσκληση για την ανάπτυξη της ομάδας.',
    inviteAthletes: 'Προσκαλέστε αθλητές',
    follower: 'Ακολουθητές'
  },
  editProfile: {
    sport: 'Αθλητισμός',
    selectSuport: 'Επιλέξτε Sport',
    favoriteTeam: 'Αγαπημένη ομάδα',
    selectTeam: 'Επιλέξτε ομάδα',
    favoritePlayer: 'Αγαπημένος παίκτης',
    selectPlayer: 'Επιλέξτε παίκτη',
    addMoreSport: 'Προσθέστε περισσότερα αθλήματα',
    editProfile: 'Επεξεργασία προφίλ',
    dateOfBirth: 'Ημερομηνία γέννησης',
    bio: 'Bio',
    mySport: 'Το άθλημά μου',
    mySports: 'Τα αθλήματά μου',
    position: 'Θέση',
    selectPosition: 'Επιλέξτε θέση',
    level: 'Επίπεδο',
    selectLevel: 'Επιλέξτε επίπεδο',
    personalInformation: 'Προσωπικές πληροφορίες',
    myGender: 'Το φύλο μου',
    female: 'Θηλυκό',
    male: 'Αρσενικό',
    other: 'Άλλο',
    imFrom: 'Είμαι από',
    yourPhoneNumber: 'Ο αριθμός τηλεφώνου σας'
  },
  profile: {
    wantToConnect: 'Θέλετε να έρθετε σε επαφή πρόσωπο με πρόσωπο;',
    favoriteSports: 'Αγαπημένα αθλήματα',
    favoriteAthlete: 'Αγαπημένος αθλητής',
    referAndReward: 'Ανταμειφθείτε παραπέμποντας έναν αθλητή',
    invitePeople: 'Προσκαλέστε τους ανθρώπους',
    earnMoreReferralFees: 'Κερδίστε περισσότερες αμοιβές παραπομπής προσκαλώντας αθλητές γύρω σας',
    inviteAthleteFan: 'Προσκαλέστε αθλητές και οπαδούς',
    typeEmailToInvite:
      'Πληκτρολογήστε email για να στείλετε μια πρόσκληση για την ανάπτυξη της ομάδας.',
    athleteEmail: 'Email αθλητή',
    doesntExists: 'Αυτός ο χρήστης δεν υπάρχει.',
    latestShoutouts: 'Τελευταίες αναφωνήσεις',
    mySports: 'Τα αθλήματά μου',
    myEquipment: 'Ο εξοπλισμός μου',
    relatedProducts: 'Σχετικά προϊόντα',
    bidForEquipment: 'Προσφορά για τον εξοπλισμό μου',
    goToAppSettings: 'Μεταβείτε στις ρυθμίσεις APP',
    recentShoutouts: 'Πρόσφατες αναφωνήσεις',
    recentUpdates: 'Πρόσφατες ενημερώσεις',
    trendingPosts: 'Τρέχοντες ανεμιστήρες',
    following: 'Ακολουθώντας το',
    userNotFound: 'Ο χρήστης @{{username}} δεν βρέθηκε',
    searchFriendsAndFollowers: 'Αναζήτηση φίλων και οπαδών',
    noUpdatesYet: '{{name}} δεν έχει ενημερώσεις ακόμα',
    noPostsYet: '{{name}} δεν έχει δημοσιεύσει ακόμα',
    followToKnowFirst:
      'Ακολουθήστε το {{name}} για να είστε οι πρώτοι που γνωρίζουν ενημερώσεις όπως podcast ή ζωντανή ροή.',
    encourage: 'Μη διστάσετε να τους στείλετε ένα μήνυμα για να τους ενθαρρύνετε.',
    threeMonthsAccess: 'Έχετε τρεις μήνες απεριόριστη πρόσβαση σε κλειστές πόρτες',
    enjoyFreeAccess: 'Απολαύστε το αποκλειστικό περιεχόμενο από τους αθλητές.',
    repostHeader:
      'Ο χρήστης <strong> {{owner}} <\/strong> μοιράστηκε την ανάρτηση <strong> {{originalOwner}} <\/strong>',
    nowFollowing: 'Τώρα ακολουθεί το {{name}}',
    sureToRemove:
      'Είστε σίγουροι ότι θέλετε να καταργήσετε το λογαριασμό σας; Αυτή η ενέργεια είναι μη αναστρέψιμη.',
    getUnlimited: 'Πάρτε απεριόριστο περιεχόμενο',
    getUnlimitedDesc:
      'Εγγραφείτε στον αγαπημένο σας αθλητή για να ενημερώνεστε με αποκλειστικό περιεχόμενο.',
    verifiedAthlete: 'Επαληθευμένος αθλητής'
  },
  notifications: {
    notifications: 'Ειδοποιήσεις',
    comingUpConnect: 'Έρχεται ένας προς έναν με τον {{sender}} σε πέντε λεπτά',
    connectRequest: 'Αίτημα ένας προς έναν από τον {{sender}}',
    connectStatus: '{{status}} ένας προς έναν με τον {{sender}}',
    connectStarting:
      'Ήρθε η ώρα να ξεκινήσετε την κράτησή σας 15 λεπτά ένας προς έναν με {{sender}}',
    commentedToPost: 'σχολίασε την ανάρτησή σας',
    commentedToSportChat: '<strong>{{sender}}</strong> \ncommented on your sport chat',
    reactedToPost: 'αντέδρασε στη θέση σας',
    reactedToShoutout: 'αντέδρασε στην αναφώνησή σας',
    amountReactedToPost: '{{amount}} άτομα αντέδρασαν στη δημοσίευσή σας',
    aNewShoutout: 'Έχετε ένα νέο shoutout',
    newShoutouts: 'Έχετε {{amount}} νέα shoutouts',
    shoutoutReaction: 'Ο {{sender}} αντέδρασε στην κραυγή σας',
    startedFollowing: '{{sender}} άρχισε να σας ακολουθεί',
    amountStartedFollowing: '{{amount}} χρήστες άρχισαν να σας ακολουθούν',
    newSub: 'Έχετε έναν νέο συνδρομητή',
    newSubs: 'Έχετε {{amount}} νέους συνδρομητές',
    newRequests: '{{amount}} νέα αιτήματα για ένα-προς-ένα',
    newFollower: 'σας ακολούθησε',
    taggedInPost: '<strong>{{sender}}<\/strong> \nσας χαρακτήρισε στην ανάρτησή του',
    mentionedInPost: '<strong>{{sender}}<\/strong> \nσας ανέφερε στην ανάρτησή του',
    commentTagged: '<strong>{{sender}}<\/strong> \nσας χαρακτήρισε στο σχόλιό του',
    p4pMonetizingYourBrand: 'P4P αξιοποιεί το brand σας!',
    fanRequestingShoutout: 'Ένας θαυμαστής ζητά έναν χαιρετισμό.',
    view: 'Προβολή',
    congratulations: 'Συγχαρητήρια!',
    yourFavoriteAthleteCompletedYourRequest:
      'Ο αγαπημένος σας αθλητής έχει ολοκληρώσει τον χαιρετισμό σας.',
    sorryFavoriteAthleteCurrentlyUnavailable:
      'Λυπούμαστε, ο αγαπημένος σας αθλητής δεν είναι αυτή τη στιγμή διαθέσιμος. Παρακαλώ δοκιμάστε ξανά αργότερα ή επιλέξτε άλλον παίκτη.',
    sportChatCommentTagged: '<strong>{{sender}}</strong> \ntagged you in their sport chat comment',
    startedSubscribing: '<strong>{{sender}}<\/strong> \nείναι πλέον συνδρομητής σας'
  },
  repost: {
    tagFriends: 'Ετικέτα φίλοι',
    repost: 'Αναδημοσίευση',
    create: 'Δημιουργία',
    yourComment: 'Το σχόλιό σας',
    shareWith: 'Μοιραστείτε με',
    everyone: 'Όλοι',
    OnlyPeopleIFollowBack: 'Μόνο οι άνθρωποι που ακολουθώ πίσω'
  },
  onBoarding: {
    everybody: 'ΟΛΟΙ',
    plays: 'ΠΑΙΧΝΙΔΙΑ',
    better: 'ΚΑΛΥΤΕΡΟ',
    together: 'ΜΑΖΙ.',
    favoriteSports: 'Αγαπημένα αθλήματα',
    chooseSports:
      'Επιλέξτε αθλήματα και επιλέξτε την αγαπημένη σας ομάδα αθλητών που θα σας κρατάει ενήμερους.',
    selectSport: 'Επιλέξτε άθλημα',
    sport: 'Αθλητισμός',
    favoriteTeam: 'Αγαπημένη ομάδα',
    selectTeam: 'Επιλέξτε ομάδα',
    favoritePlayer: 'Αγαπημένος παίκτης',
    selectPlayer: 'Επιλέξτε παίκτη',
    addMoreSport: 'Προσθέστε περισσότερα αθλήματα',
    getStarted: 'Ξεκινήστε',
    youreAlmostThere: 'Σχεδόν φτάσατε',
    tellUsAboutYourself:
      'Πείτε μας για τον εαυτό σας για να λαμβάνετε τις πιο σχετικές ροές και ενημερώσεις.',
    imFrom: 'Είμαι από',
    yourPhoneNumber: 'Ο αριθμός τηλεφώνου σας',
    dateOfBirth: 'Ημερομηνία γέννησης',
    monthlyRevenueTarget: 'Στόχος για τα έσοδα του μήνα',
    pleaseShareYour:
      'Παρακαλούμε μοιραστείτε τις μηνιαίες προσδοκίες σας για τα έσοδα. Οι θαυμαστές δεν θα το δουν αυτό στο προφίλ σας.',
    next: 'Επόμενο',
    skipThisStep: 'Παραλείψτε αυτό το βήμα',
    yourSports: 'Τα αθλήματά σας',
    chooseASport: 'Επιλέξτε ένα άθλημα και επιλέξτε τη θέση σας.',
    mySport: 'Το άθλημά μου',
    position: 'Θέση',
    selectPosition: 'Επιλέξτε θέση',
    addSecondarySport: 'Προσθέστε δευτερεύον άθλημα',
    chooseSportsYou: 'Επιλέξτε αθλήματα που σας ενδιαφέρουν.',
    skipAndGet: 'Παραλείψτε και ξεκινήστε',
    connectDirectlyWith: 'Συνδεθείτε απευθείας με τους αγαπημένους σας αθλητές και άλλους οπαδούς.',
    monetizeYourBrand:
      'Αξιοποιήστε το εμπορικό σήμα σας δημιουργώντας έναν μοναδικό κόσμο με τους θαυμαστές σας.',
    chooseAUsername: 'Επιλέξτε ένα όνομα χρήστη',
    referralCodeOptional: 'Κωδικός παραπομπής (προαιρετικά)',
    backTo: 'Πίσω στο',
    logIn: 'Συνδεθείτε',
    imAFan: 'Είμαι οπαδός',
    imAnAthlete: 'Είμαι αθλητής',
    createAnAccount: 'Δημιουργία λογαριασμού',
    searchTeams: 'Ομάδες αναζήτησης'
  },
  shoutout: {
    success: 'Το Shoutout στάλθηκε επιτυχώς.',
    comingSoon: 'Shoutout έρχεται σύντομα',
    comingSoonDesc:
      'Επικοινωνήστε με διάσημους αθλητές σε όλο τον κόσμο, στέλνοντας ενθαρρυντικά και πανηγυρικά shoutouts.',
    selectTeamOrAthete: 'Επιλέξτε μια Ομάδα ή Αθλητή',
    teamOrAthlete: 'Ομάδα/Αθλητής',
    writeShoutout: 'Γράψτε μια κραυγή',
    createMatchDayShoutout: 'Δημιουργία Ανακοίνωσης Αγώνα',
    matchDayShoutouts: 'Ανακοινώσεις Αγώνα',
    shoutoutsFromAthletes: 'Από Αθλητές',
    shoutoutsFromFans: 'Από οπαδούς'
  },
  shop: {
    comingSoon: 'Το κατάστημα έρχεται σύντομα',
    comingSoonDesc:
      'Είδη από τους αγαπημένους σας διάσημους αθλητές, εισιτήρια για εκδηλώσεις, αποκλειστικές προσφορές και πολλά άλλα θα είναι διαθέσιμα μέσω του άνετου καταστήματός μας. Θα σας ενημερώσουμε σύντομα για τα εγκαίνια.'
  },
  header: {
    logOutConfirmation:
      'Να αποσυνδεθείτε από το λογαριασμό σας; Μπορείτε να συνδεθείτε αργότερα χρησιμοποιώντας τα διαπιστευτήριά σας.',
    upgradePlan: 'Σχέδιο αναβάθμισης'
  },
  post: {
    timestampYear: 'y',
    timestampMonth: 'm',
    timestampWeek: 'w',
    timestampDays: 'd',
    timestampHour: 'h',
    timestampSecond: 's',
    deletePost: 'Διαγραφή ανάρτησης',
    editPost: 'Επεξεργασία ανάρτησης',
    reportPost: 'Αναφορά θέσης',
    areYouSure: 'Είστε σίγουρος ότι θέλετε να διαγράψετε την ανάρτησή σας;',
    reportingSoon:
      'Η υποβολή εκθέσεων δεν είναι ακόμη διαθέσιμη. Παρακαλούμε να επανέλθετε αργότερα.',
    beingProcessed: 'Αυτό το βίντεο βρίσκεται υπό επεξεργασία, παρακαλώ επιστρέψτε αργότερα.'
  },
  billing: {
    billing: 'Τιμολόγηση',
    settings: 'Ρυθμίσεις',
    history: 'Ιστορία',
    billingInformation: 'Πληροφορίες χρέωσης',
    paymentMethod: 'Μέθοδος πληρωμής',
    addPaymentMethod: 'Προσθήκη μεθόδου πληρωμής',
    youNeedToAddMethod: 'Πρέπει να προσθέσετε μια μέθοδο πληρωμής',
    forYourPurches:
      'Θα μεταφερθείτε στην εφαρμογή μας στο διαδίκτυο για να προσθέσετε τη μέθοδο πληρωμής σας.',
    goToWebApp: 'Πήγα στην εφαρμογή web',
    exp: 'Exp',
    removingCard: 'Αυτή η κάρτα θα αφαιρεθεί',
    sureToRemove: 'Είστε σίγουροι ότι θέλετε να καταργήσετε το **** {{last4}};',
    noPaymentsYet: 'Δεν υπάρχουν πληρωμές ακόμη',
    processedPaymentsHere: 'Εδώ θα δείτε τη λίστα των πληρωμών που έχουν διεκπεραιωθεί.',
    shoutoutTo: 'Shoutout to {{name}}',
    connectWith: 'Συνδεθείτε ένας προς έναν με το {{name}}',
    connectRefused: 'Η σύνδεση ένας προς έναν απορρίφθηκε από τον χρήστη {{name}}',
    connectCanceledBy: 'Η σύνδεση ένας προς έναν ακυρώθηκε από τον {{name}}',
    termsAndConditions:
      'Σύμφωνα με τους όρους και τις προϋποθέσεις, αποδέχομαι να χρεωθώ με το ποσό που αναφέρεται παραπάνω κατά την επιβεβαίωση του p4p.',
    swipeRightToPurchase: 'Σαρώστε δεξιά για να αγοράσετε',
    subscription: 'Εγγραφείτε στο {{name}}',
    purchase: 'Αγορά'
  },
  revenueTarget: {
    none: 'Κανένας',
    oneThousand: 'Μέχρι $1,000',
    fiveThousand: 'Μέχρι 5.000 δολάρια',
    tenThousand: 'Μέχρι 10.000 δολάρια',
    hundredThousand: 'Μέχρι $100,000',
    oneMillion: 'Μέχρι 1.000.000 δολάρια',
    moreThanMillion: 'Πάνω από 1.000.000 δολάρια'
  },
  forgotPassword: {
    recoveryEmailSent: 'Στάλθηκε email ανάκτησης',
    checkYourInbox:
      'Ελέγξτε τα εισερχόμενά σας (και τους φακέλους ανεπιθύμητης αλληλογραφίας) για να βρείτε και να ακολουθήσετε τις οδηγίες για την επαναφορά του κωδικού πρόσβασής σας.',
    backToLogin: 'Επιστροφή στην σελίδα εισόδου',
    passwordReset: 'Επαναφορά κωδικού πρόσβασης',
    enterEmail:
      'Εισάγετε το email που σχετίζεται με το λογαριασμό σας και θα σας στείλουμε τις οδηγίες ανάκτησης του κωδικού πρόσβασης.',
    sendRecovery: 'Αποστολή email ανάκτησης',
    checkEmail: 'Ελέγξτε τη διεύθυνση email σας',
    noAccount: 'Δεν υπάρχει σχετικός λογαριασμός',
    anotherAddress: 'Παρακαλώ δοκιμάστε άλλη διεύθυνση.',
    tryAnother: 'Δοκιμάστε άλλο email',
    createNewPassword: 'Δημιουργία νέου κωδικού πρόσβασης',
    doesntMatch: 'Δεν ταιριάζει',
    newPassword: 'Νέος κωδικός πρόσβασης',
    resetPassword: 'Επαναφορά κωδικού πρόσβασης',
    passwordRule1: 'Ο νέος κωδικός πρόσβασης θα πρέπει να είναι διαφορετικός από τον προηγούμενο.',
    passwordRule2: 'Τουλάχιστον 8 χαρακτήρες - όσο περισσότεροι χαρακτήρες, τόσο το καλύτερο.',
    passwordRule3: 'Μείγμα κεφαλαίων και πεζών γραμμάτων.',
    passwordRule4: 'Μείγμα γραμμάτων και αριθμών.',
    passwordRule5: 'Τουλάχιστον ένας ειδικός χαρακτήρας, π.χ. ! @ # ?'
  },
  getTheApp: {
    header: 'Κατεβάστε την εφαρμογή playaz4playaz APP για το smartphone σας',
    setupAccount:
      'Κατεβάστε την εφαρμογή playaz4playaz για το smartphone σας για να ρυθμίσετε τον λογαριασμό σας.'
  },
  share: {
    repost: 'Αναδημοσίευση',
    copyLink: 'Αντιγραφή συνδέσμου',
    viaMessage: 'Κοινοποίηση μέσω μηνύματος',
    toFb: 'Μοιραστείτε το στο facebook',
    toInst: 'Κοινοποίηση στο Instagram',
    toTwit: 'Μοιραστείτε το στο Twitter',
    toWhapp: 'Κοινή χρήση στο WhatsApp',
    toTelg: 'Κοινή χρήση στο Telegram',
    viaEmail: 'Μοιραστείτε μέσω email'
  },
  verification: {
    verifyProfile: 'Επαλήθευση προφίλ',
    verifyProfile2: 'Επαλήθευση προφίλ',
    accountNeedsVerification:
      'Ο λογαριασμός σας χρειάζεται επαλήθευση. Παρακαλώ τραβήξτε μια φωτογραφία με την ταυτότητά σας δίπλα στο πρόσωπό σας. Μπορείτε να το κάνετε αργότερα από το προφίλ.',
    needVerification:
      'Ο λογαριασμός σας χρειάζεται επαλήθευση για να συμμετάσχει στις κλήσεις ένας προς έναν.',
    yourProfileVerified: 'Το προφίλ σας επαληθεύτηκε',
    verificationRequested: 'Ζητούμενη επαλήθευση',
    beingVerified:
      'Το προφίλ επαληθεύεται εντός 24 ωρών. Αφού ολοκληρωθεί - μπορείτε να μπείτε σε σύνδεση ένας προς έναν μετά την επεξεργασία της πληρωμής.',
    profileVerifiedDescription:
      'Ευχαριστώ για την ολοκλήρωση της επαλήθευσης. Τώρα μπορείτε να μπείτε στο προγραμματισμένο τετ-α-τετ.'
  },
  events: {
    shoutouts: 'Εκφωνήσεις',
    livescore: 'Ζωντανά αποτελέσματα',
    pictures: 'Εικόνες',
    stats: 'Στατιστικά στοιχεία',
    noShoutouts: 'Δεν υπάρχουν ακόμα αναφωνήσεις σε αυτό το γεγονός',
    addShoutout: 'Στείλτε ένα τώρα για να είστε ο πρώτος που θα φωνάξει!'
  },
  games: {
    ht: 'Ημίχρονο',
    ft: 'Τελικός χρόνος\n',
    matchday: 'Αγωνιστική {{round}}',
    roundOf16: 'Γύρος των 16',
    quarterFinal: 'Προημιτελικός',
    semiFinal: 'Ημιτελικός',
    playOff: 'Πλέι οφ',
    playoffFinal: 'Τελικός πλέι οφ',
    final: 'Τελικό',
    preSeason: 'Προετοιμασία για τη σεζόν ',
    playOffSemiFinal: 'Ημιτελικός πλέι οφ',
    wantToShoutout: 'Θέλετε να φωνάξετε;'
  },
  permissions: {
    permissionsBlocked: 'Αποκλεισμός δικαιωμάτων',
    goToYourSettings:
      'Παρακαλούμε μεταβείτε στις ρυθμίσεις σας και ενεργοποιήστε την {{permission}}',
    openSettings: 'Άνοιγμα ρυθμίσεων',
    camera: 'Κάμερα',
    microphone: 'Μικρόφωνο',
    gallery: 'Γκαλερί'
  },
  store: {
    suggestedItems: 'Προτεινόμενα στοιχεία',
    liked: 'Μου άρεσε',
    merchandise: 'Εμπορεύματα',
    tickets: 'Εισιτήρια',
    fromSubscribed: 'Από εγγεγραμμένους αθλητές',
    productDetails: 'Λεπτομέρειες προϊόντος',
    selectSize: 'Επιλέξτε μέγεθος',
    selectStock: 'Επιλέξτε τύπο',
    seeSizeGuide: 'Δείτε τον οδηγό μεγεθών',
    currentBid: 'Τρέχουσα προσφορά',
    placeBid: 'Τοποθετήστε προσφορά',
    likedProducts: 'Αγαπημένα προϊόντα',
    noLiked: 'Δεν έχουν αρέσει τα προϊόντα ακόμα',
    addToCart: 'Προσθήκη στο καλάθι',
    cart: 'Καλάθι',
    totalCost: 'Συνολικό κόστος: ',
    checkout: 'Ταμείο',
    orderSuccessful: 'Παραγγελία Επιτυχής',
    size: 'Μέγεθος',
    price: 'Τιμή',
    proceedToPayment: 'Προχωρήστε στην πληρωμή',
    sizeWithDesc: '{{size}} μέγεθος',
    clearAll: 'Εκκαθάριση όλων'
  },
  goLive: {
    onlineCount: '{{onlineCount}} συνδρομητές online',
    onlineCountFan: '{{onlineCount}} οπαδοί στο διαδίκτυο',
    watchingCount: '{{watchingCount}} watching',
    youAreLive: 'Είστε ζωντανά!',
    streamIsFinished: 'Η ροή έχει τελειώσει.',
    live: 'LIVE',
    end: 'Τέλος',
    comment: 'Σχόλιο',
    tapForGoLive: 'Πατήστε για go live'
  },
  subscribe: {
    monthly: 'Μηνιαία',
    annual: 'Ετήσια',
    off: '{{amount}}% OFF',
    upToOff: 'ΈΩΣ {{amount}}% έκπτωση',
    athletesAndTeams: 'Αθλητές και ομάδες',
    subscribeFor: 'Εγγραφείτε για <strong>{{amount}}\/μήνα<\/strong>',
    subscriptionSummary: 'Περίληψη συνδρομής',
    introductoryOffer: 'Εισαγωγική προσφορά',
    annualDiscount: 'Πληρώστε 10 μήνες για 12 με ετήσια έκπτωση',
    noResults: 'Δεν βρέθηκαν αποτελέσματα με τα κριτήρια που ταιριάζουν',
    teamFan: '{{team}} οπαδός;',
    subscribeForTeam:
      'Εγγραφείτε για όλους τους αθλητές της ομάδας από <strong>{{amount}}\/μήνα<\/strong>',
    seeAllAthletes: 'Δείτε όλους τους {{number}} αθλητές',
    subscribeModalTitle: 'Εγγραφείτε στους αγαπημένους σας αθλητές και ομάδες',
    subscribeModalDesc:
      'Απολαύστε το αποκλειστικό περιεχόμενο από τους αθλητές και τις ομάδες. Εγγραφείτε στις ομάδες και αποκτήστε πλήρη πρόσβαση στους παίκτες από 5,99 δολάρια.',
    athletesToSubscribe: 'Αθλητές που θα εγγραφούν',
    numberAthletes: '{{amount}} αθλητές',
    cancelSubscription: 'Ακύρωση συνδρομής',
    daysLeftInPeriod: '{{amount}} ημέρες που απομένουν στην τρέχουσα περίοδο',
    sureToCancel: 'Είστε σίγουροι ότι θέλετε να ακυρώσετε τη συνδρομή σας;',
    bundleSquad: '{{name}} ομάδα',
    remindMeLater: 'Θύμισέ μου αργότερα'
  },
  americanFootball: {
    quarterback: 'Quarterback',
    runningBack: 'Τρέξιμο πίσω',
    wideReceiver: 'Ευρύς δέκτης',
    tightEnd: 'Σφιχτό τέλος',
    leftGuard: 'Αριστερός φρουρός',
    rightGuard: 'Δεξιά φρουρά',
    center: 'Κέντρο',
    leftTackle: 'Αριστερή αμυντική γραμμή',
    rightTackle: 'Δεξί Τackle',
    noseTackle: 'Μύτη γάντζο',
    defensiveTackles: 'Αμυντικές τάκλες',
    offensiveTackles: 'Επιθετικά τάκλιν',
    offensiveLineman: 'Επιθετικός αμυντικός',
    middleLineBacker: 'Υποστηρικτής μεσαίας γραμμής',
    outsideLineBacker: 'Εξωτερικός αμυντικός γραμμής',
    defensiveBack: 'Αμυντική πλάτη',
    flanker: 'Flanker',
    splitEnd: 'Split End',
    kicker: 'Δύστροπος',
    punter: 'Punter',
    cornerback: 'Κόρνερμπακ',
    safety: 'Ασφάλεια',
    defensiveEnd: 'Αμυντικό τέλος',
    runningBackHalfback: 'Τρέξιμο πίσω (Halfback)',
    runningBackFullback: 'Τρέξιμο πίσω (Fullback)'
  },
  baseball: {
    centerFielder: 'Κεντρικός Αμυντικός',
    pitcher: 'Κανάτα',
    catcher: 'Συλλέκτης',
    baseman: 'Μπέιζμαν',
    shortstop: 'Σύντομη στάση',
    leftFielder: 'Αριστερός Φίλντερ',
    rightFielder: 'Δεξί Fielder',
    firstBaseman: 'Πρώτος Baseman',
    secondBaseman: 'Δεύτερος Baseman',
    thirdBaseman: 'Τρίτος Baseman',
    designatedHitter: 'Καθορισμένος Χίτερ'
  },
  basketball: {
    pointGuard: 'Πόιντ Γκαρντ',
    shootingGuard: 'Σούτινγκ Γκαρντ',
    smallForward: 'Σμολ Φόργουορντ',
    powerForward: 'Πάουερ Φόργουορντ',
    center: 'Κέντρο',
    comboGuard: 'Combo Guard',
    wingGuard: 'Φρουρά πτέρυγας',
    pointForward: 'Point Forward',
    comboForward: 'Combo Forward'
  },
  cricket: {
    captain: 'Καπετάνιος',
    wicketkeeper: 'Wicketkeeper',
    slip: 'Γλιστρώ',
    gully: 'Λούκι',
    point: 'Σημείο',
    cover: 'Εξώφυλλο',
    thirdMan: 'Τρίτος άνθρωπος',
    fineLeg: 'Λεπτό πόδι',
    midWicket: 'Midfielder Wicket',
    midOff: 'Μεσοεπιθετικός Off',
    squareLeg: 'Τετράγωνο πόδι'
  },
  soccer: {
    goalkeeper: 'Τερματοφύλακας',
    striker: 'Επιθετικός',
    centerbackStopper: 'Κεντρικός αμυντικός (στόπερ)',
    centerbackSweeper: 'Κεντρικός αμυντικός (σκούπα)',
    centerbackQuarterBack: 'Κεντρικός αμυντικός (quarter-back)',
    rightFullback: 'Δεξί αμυντικό χαφ',
    leftFullback: 'Αριστερός αμυντικός',
    centerForward: 'Σέντερ φορ',
    wingers: 'Εξτρέμ',
    leftMid: 'Αριστερός μέσος',
    wideMid: 'Ευρύς μέσος',
    rightMid: 'Δεξιός μέσος',
    centerMid: 'Κεντρικός μέσος',
    attackingMid: 'Μεσοεπιθετικός',
    defensiveMid: 'Αμυντικός μέσος',
    defensiveMidBallWinner: 'Αμυντικός μέσος (νικητής της μπάλας)',
    defensiveMidDeepLyingPlaymaker: 'Αμυντικός μέσος (βαθύς πλέι μέικερ)',
    boxToBoxMid: 'Box-to-box μέσος',
    wingback: 'Ακραίος\/Ακροδεξιά',
    false9: 'Λάθος 9',
    raumdeuter: 'Raumdeuter',
    forward: 'Εμπρός'
  },
  tennis: {
    oneUp: 'Ένα επάνω',
    oneBack: 'Μία πλάτη'
  },
  handball: {
    goalkeeper: 'Τερματοφύλακας',
    leftBack: 'Αριστερά Πίσω',
    centerBack: 'Κέντρο Πίσω\/Κέντρο',
    rightBack: 'Δεξιά Πίσω',
    leftWinger: 'Αριστερός εξτρέμ',
    centerForward: 'Κέντρο προς τα εμπρός \/ περιστρεφόμενος \/ κυκλικός δρομέας',
    rightWinger: 'Δεξιός ακροδεξιός',
    farRight: 'Ακροδεξιά',
    halfRight: 'Μισή Δεξιά',
    backCenter: 'Πίσω κέντρο',
    frontCenter: 'Μπροστινό κέντρο'
  },
  iceHockey: {
    leftDefenseman: 'Αριστερός αμυντικός',
    goaltender: 'Τερματοφύλακας\/γκολιέρα',
    rightDefenseman: 'Δεξιός αμυντικός',
    leftWinger: 'Αριστερός εξτρέμ',
    center: 'Κέντρο',
    rightWinger: 'Δεξιός ακροδεξιός'
  },
  lacrosse: {
    attackmen: 'Επιτιθέμενοι',
    mid: 'Μεσοεπιθετικός',
    defensemen: 'Αμυντικοί',
    goalkeeper: 'Τερματοφύλακας'
  },
  polo: {
    lowWingLeftWing: 'Χαμηλή πτέρυγα\/αριστερή πτέρυγα',
    lowWingRightWing: 'Χαμηλή πτέρυγα\/δεξιά πτέρυγα',
    centerHoleSet: 'Σετ κέντρου\/οπής',
    topWingLeftFlat: 'Πάνω πτέρυγα\/αριστερό επίπεδο',
    topWingRightFlat: 'Πάνω πτέρυγα\/δεξιά επίπεδη',
    point: 'Σημείο',
    cornerPost: 'Γωνία\/Στύλος',
    middleDefense: 'Μέση\/Άμυνα',
    topDefense: 'Κορυφαία άμυνα'
  },
  rowing: {
    coxswain: 'Κυβερνήτης',
    rower: 'Αναβατήρας'
  },
  softball: {
    pitcher: 'Κανάτα',
    catcher: 'Συλλέκτης',
    firstBaseman: 'Πρώτος Baseman',
    secondBaseman: 'Δεύτερος Baseman',
    shortstop: 'Shortstop',
    thirdBaseman: 'Τρίτος Baseman',
    leftFielder: 'Αριστερός Φίλντερ',
    centerFielder: 'Δεξί Fielder',
    rightFielder: 'Δεξί Fielder'
  },
  rugby: {
    looseheadProp: 'Στήριγμα χαλαρής κεφαλής',
    hooker: 'Hooker',
    tightheadProp: 'Στήριγμα σφιχτής κεφαλής',
    lock2ndRow: 'Κλείδωμα\/2η σειρά',
    blindSideFlanker: 'Blind-side Flanker',
    openSideFlanker: 'Open-side Flanker',
    number8: 'Αριθμός 8',
    scrumHalf: 'Scrum Half',
    flyHalf: 'Fly Half',
    leftWing: 'Αριστερή πτέρυγα',
    insideCenter: 'Εσωτερικό κέντρο',
    outsideCenter: 'Εξωτερικό κέντρο',
    rightWing: 'Δεξιά Πτέρυγα',
    fullback: 'Φούλμπακ'
  },
  volleyball: {
    setter: 'Setter',
    outsideHitter: 'Εξωτερικός Χίτερ',
    middleBlocker: 'Μεσαίο μπλοκέρ',
    libero: 'Libero',
    oppositeHitter: 'Απέναντι Hitter'
  },
  stories: {
    subscribeTo: 'Εγγραφείτε για να έχετε πρόσβαση σε περισσότερες ιστορίες από {{name}}'
  },
  reports: {
    descriptionPlaceholder: 'Περιγράψτε τον λόγο...',
    reportingPost: 'Αναφορά της δημοσίευσης {{name}}',
    reportingShoutout: 'Αναφορά της φωνής του {{name}}',
    reportingStory: 'Αναφορά της ιστορίας του {{name}}',
    report: 'Αναφορά'
  },
  error: {
    noNetwork: 'No network connection',
    somethingWentWrong: 'Κάτι πήγε στραβά!',
    pleaseTryAgainLater: 'Προσπαθήστε ξανά αργότερα.'
  },
  requestShoutout: {
    discardChanges: 'Απορρίψετε τις αλλαγές;',
    selectAthlete: 'Επιλογή αθλητή',
    newRequest: 'Νέο Αίτημα',
    requestAShoutout: 'Ζήτηση ενός χαιρετισμού',
    itsMine: 'Είναι δικό μου',
    forSomeoneElse: 'Για κάποιον άλλον',
    whatIsYourName: 'Πώς σε λένε;',
    introduction: 'Παρουσιαστείτε',
    selectOcassion: 'Επιλέξτε περίσταση/λόγο',
    birthday: 'Γενέθλια',
    anniversary: 'Επέτειος',
    motivational: 'Ενθαρρυντικός',
    mentorship: 'Μεντορία',
    gender: 'γένος',
    addInstruction: 'Προσθέστε οδηγία (τι θα θέλατε να πουν)',
    deliveryInfo: 'Πληροφορίες Παράδοσης',
    standard: 'Τυπικό',
    videoDelivered: 'Το βίντεο θα παραδοθεί σε {{day}} ημέρες',
    requestSent: 'Το αίτημά σας έχει σταλεί!',
    requestConfirmation:
      'Μόλις στείλαμε το αίτημα σας για χαιρετισμό προς {{athlete}}. Ενώ ο χρόνος ολοκλήρωσης φτάνει μέχρι και {{day}} ημέρες, είμαστε αισιόδοξοι ότι μπορεί να γίνει ακόμα και νωρίτερα.',
    whoThisFor: 'Για ποιον είναι αυτό;',
    standard: 'Τυπικό ({{price}})',
    bookNow: 'Κάντε Κράτηση Τώρα',
    backToShoutout: 'Πίσω στους Χαιρετισμούς',
    maximum18Chars: 'Μέγιστο 18 χαρακτήρες',
    maximum200Chars: 'Μέγιστο 200 χαρακτήρες',
    youCanAdd18Chars: 'Μπορείτε να πληκτρολογήσετε έως και 18 χαρακτήρες',
    youCanAdd200Chars: 'Μπορείτε να πληκτρολογήσετε έως και 200 χαρακτήρες'
  },
  yourRequests: {
    view: 'Προβολή',
    yourRequests: 'Οι αιτήσεις σου',
    myShoutoutRequests: 'Οι αιτήσεις μου για χαιρετισμούς',
    shoutoutRequestsFromFans: 'Shoutout Requests from Fans',
    face2faceRequests: 'Αιτήματα Face2face',
    all: 'Όλα',
    pending: 'εκκρεμεί',
    completed: 'Έγινε',
    unfulfilled: 'Ατελής',
    fromAthletes: 'Από Αθλητές',
    fromFans: 'Από οπαδούς',
    dayLeft: '{{dayLeft}} Ημέρα απομένει',
    daysLeft: '{{dayLeft}} Ημέρες που απομένουν',
    fulfilledOn: 'Ολοκληρώθηκε στις {{date}}',
    unfulfilledOn: 'Μη εκπληρωμένο στις {{date}}',
    decline: 'Απορρίπτω',
    startRecording: 'Ξεκινήστε την εγγραφή',
    record: 'Εγγραφή',
    tapForRecording: 'Πατήστε για εγγραφή',
    send: 'Στείλετε',
    completeTheRequest: 'Ολοκληρώστε το αίτημα',
    discardChanges: 'Απορρίψετε τις αλλαγές;',
    confirm: 'Επιβεβαιώστε',
    cancel: 'Ματαίωση',
    awesome: 'Φοβερό!',
    shoutoutSuccessfullySent: 'Ο χαιρετισμός σας στάλθηκε με επιτυχία!',
    declineTheRequest: 'Απόρριψη του αιτήματος',
    busyConsiderToProfit:
      'Καταλαβαίνουμε ότι είστε απασχολημένος, παρακαλούμε να λάβετε υπόψη να εξασφαλίσετε κέρδος από το brand σας στο επόμενο αίτημα του οπαδού.'
  },
  shoutoutsVideoGallery: {
    fromMe: 'Από Μένα',
    fromFellowAthletes: 'Από Συναθλητές',
    for: 'Για {{name}}'
  },
  letsChatSports: {
    startChat: 'Start Chat',
    writeTopic: 'Write a topic'
  }
};
